(function () {
  'use strict';
  if (window.NTCart) return;
  window.ntMiniControlsReady = true;
  var busy = false;
  var copy = JSON.parse(document.querySelector('[data-nt-cart-copy]').textContent);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function message(key) { return copy[key] || copy.update_error; }
  function status(text) {
    document.querySelectorAll('[data-mini-status],[data-nt-cart-status]').forEach(function (node) { node.textContent = text; });
  }
  function targets() {
    return Array.from(document.querySelectorAll('[data-mini-section],[data-nt-cart-section]')).map(function (node) {
      return {node: node, id: node.dataset.miniSection || node.dataset.ntCartSection, mini: node.hasAttribute('data-mini-section')};
    });
  }
  function setCount(count) {
    if (!Number.isFinite(count)) return;
    document.querySelectorAll('[data-nt-cart-count],[data-cart-count],.cart-count,.js-cart-count').forEach(function (node) {
      if (!node.children.length) node.textContent = String(count);
      node.hidden = count < 1;
    });
    document.querySelectorAll('.nt-cart-link').forEach(function (node) {
      node.setAttribute('aria-label', message(count === 1 ? 'label_one' : 'label_many').replace('__COUNT__', count));
    });
    document.querySelectorAll('[data-nt-cart-tooltip]').forEach(function (node) {
      node.textContent = message(count === 1 ? 'tooltip_one' : 'tooltip_many').replace('__COUNT__', count);
    });
  }
  function render(sections, cart) {
    var complete = true;
    targets().forEach(function (target) {
      var html = sections && sections[target.id];
      if (typeof html !== 'string') { complete = false; return; }
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var next = parsed.querySelector(target.mini ? '[data-mini-section]' : '[data-nt-cart-section]');
      if (!next) { complete = false; return; }
      if (target.mini) {
        var list = target.node.querySelector('.nt-mini-cart__items');
        var scroll = list ? list.scrollTop : 0;
        target.node.replaceWith(next);
        var nextList = next.querySelector('.nt-mini-cart__items');
        if (nextList) nextList.scrollTop = scroll;
        setCount(Number(next.dataset.miniCount));
      } else if (!next.querySelector('#cart_form') || !target.node.querySelector('#cart_form')) {
        target.node.replaceWith(next);
      } else {
        var agreement = target.node.querySelector('#agree');
        var accepted = agreement && agreement.checked;
        ['.nt-cart__items', '.nt-cart__summary', '.nt-cart__header'].forEach(function (selector) {
          var old = target.node.querySelector(selector), fresh = next.querySelector(selector);
          if (old && fresh) old.replaceWith(fresh);
          else complete = false;
        });
        var newAgreement = target.node.querySelector('#agree');
        if (newAgreement && agreement) newAgreement.checked = accepted;
      }
    });
    if (cart && typeof cart.item_count === 'number') setCount(cart.item_count);
    return complete;
  }
  async function recover(ids) {
    var url = new URL(location.pathname, location.origin);
    url.searchParams.set('sections', ids.join(','));
    var response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(12000)});
    if (!response.ok) throw new Error(message('sync_error'));
    if (!render(await response.json())) throw new Error(message('sync_error'));
  }
  function lock() {
    var saved = [];
    document.querySelectorAll('[data-mini-action],[data-cart-step],#cart_form input[name="updates[]"],#cart_form button[type="submit"],.nt-mini-cart button[name="checkout"]').forEach(function (node) {
      saved.push([node, node.disabled]); node.disabled = true;
    });
    document.querySelectorAll('[data-cart-remove]').forEach(function (node) { node.setAttribute('aria-disabled', 'true'); });
    targets().forEach(function (target) { target.node.setAttribute('aria-busy', 'true'); });
    return function () {
      saved.forEach(function (entry) { entry[0].disabled = entry[1]; });
      document.querySelectorAll('[data-cart-remove]').forEach(function (node) { node.removeAttribute('aria-disabled'); });
      document.querySelectorAll('[data-nt-cart-key],[data-mini-key],[data-mini-section],[data-nt-cart-section]').forEach(function (node) { node.removeAttribute('aria-busy'); });
    };
  }
  async function mutate(action, body) {
    if (busy) throw new Error(message('updating'));
    busy = true;
    var unlock = lock();
    var ids = Array.from(new Set(targets().map(function (target) { return target.id; }))).slice(0, 5);
    var headers = {Accept: 'application/json'};
    if (body instanceof FormData) {
      body.set('sections', ids.join(',')); body.set('sections_url', location.pathname);
    } else {
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(Object.assign({}, body, {sections: ids, sections_url: location.pathname}));
    }
    status(message('updating'));
    var committed = false, response;
    try {
      response = await fetch(root + 'cart/' + action + '.js', {method: 'POST', headers: headers, body: body, credentials: 'same-origin', signal: AbortSignal.timeout(20000)});
      committed = response.ok;
      var payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || message('update_error'));
      if (!render(payload.sections, payload)) await recover(ids);
      status(message('updated'));
      document.dispatchEvent(new CustomEvent('nt:cart:updated', {detail: {source: action, response: payload}}));
      return payload;
    } catch (error) {
      if (committed) {
        status(message('sync_error'));
        return {ntSyncWarning: message('sync_error')};
      }
      if (!response || response.status >= 500) {
        try { await recover(ids); } catch (_) {}
        error = new Error(message('network_error'));
      }
      status(error.message || message('update_error'));
      throw error;
    } finally { busy = false; unlock(); }
  }
  window.NTCart = {
    get busy() { return busy; },
    add: function (body) { return mutate('add', body); },
    change: function (id, quantity) { return mutate('change', {id: id, quantity: quantity}); }
  };
  function restoreInput(row) {
    var input = row.querySelector('input[name="updates[]"]');
    if (input) input.value = row.dataset.ntCartQuantity;
  }
  async function changeRow(row, quantity, button) {
    if (busy) { restoreInput(row); return; }
    var mini = row.hasAttribute('data-mini-key');
    var rowSelector = mini ? '[data-mini-key]' : '[data-nt-cart-key]';
    var key = row.dataset.miniKey || row.dataset.ntCartKey;
    var index = Array.from(document.querySelectorAll(rowSelector)).indexOf(row);
    var action = button && (button.dataset.miniAction || button.dataset.cartStep || (button.hasAttribute('data-cart-remove') ? 'remove' : ''));
    row.setAttribute('aria-busy', 'true');
    try {
      await window.NTCart.change(key, quantity);
      if (button && !button.isConnected) {
        var rows = Array.from(document.querySelectorAll(rowSelector));
        var next = rows.find(function (r) { return (r.dataset.miniKey || r.dataset.ntCartKey) === key; }) || rows[Math.min(index, rows.length - 1)];
        var focus = next && Array.from(next.querySelectorAll('button,a,input')).find(function (node) {
          return !node.disabled && (node.dataset.miniAction === action || node.dataset.cartStep === action || action === 'remove' && node.hasAttribute('data-cart-remove'));
        });
        focus = focus || document.querySelector(mini ? '[data-mini-section] a' : '[data-nt-cart-status]');
        if (focus) focus.focus({preventScroll: true});
      }
    } catch (_) { restoreInput(row); }
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mini-action],[data-cart-step],[data-cart-remove]');
    if (!button) return;
    var row = button.closest('[data-mini-key],[data-nt-cart-key]');
    if (!row) return;
    event.preventDefault();
    if (busy || button.disabled) return;
    var current = Number(row.dataset.miniQuantity || row.dataset.ntCartQuantity);
    var action = button.dataset.miniAction;
    var next = action === 'remove' || button.hasAttribute('data-cart-remove') ? 0 : current + (action ? (action === 'plus' ? 1 : -1) : Number(button.dataset.cartStep));
    if (next < 0 || !Number.isInteger(next)) return;
    changeRow(row, next, button);
  });
  document.addEventListener('change', function (event) {
    if (!event.target.matches('#cart_form input[name="updates[]"]')) return;
    var row = event.target.closest('[data-nt-cart-key]'), quantity = Number(event.target.value);
    if (!row) return;
    if (!Number.isInteger(quantity) || quantity < 1) { restoreInput(row); status(message('quantity_error')); return; }
    if (quantity !== Number(row.dataset.ntCartQuantity)) changeRow(row, quantity, event.target);
  });
  document.addEventListener('submit', function (event) {
    if (busy && (event.target.id === 'cart_form' || event.target.closest('[data-mini-section]'))) event.preventDefault();
  }, true);
})();
